export const galleyImageOptions = {
  legacy: true,
  prefix: 'X4_9_Interior',
  angle: 'galley',
  staticOptions: {
    Floorboard: 1,
    BeautyBox: 1,
    Pouffes: 1,
    CupboardsOwnersCabin: 1,
    SplitBerth: 1,
    Backrest: 1,
    TableBox: 1,
    CupboardsAftCabin: 1
  },
  mattes: []
}



// WEBPACK FOOTER //
// ./src/X49/views/galley.js